"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwardClick = void 0;
function isDescendantOf(el, predicate) {
    if (!el.parentElement)
        return false;
    if (predicate(el.parentElement))
        return true;
    return isDescendantOf(el.parentElement, predicate);
}
function isInteractive(el) {
    return "a,audio,button,input,label,menu,menuitem,option,select,summary,textarea,video"
        .split(",")
        .includes(el.tagName.toLowerCase());
}
/**
 * forwardClick allows to emulate a <label> with more control.
 * In particular, this does not click on the first nested interactive element, but on the chosen one.
 */
function forwardClick(e, selector) {
    var container = e.currentTarget;
    var forwardTarget = container.querySelector(selector);
    if (!forwardTarget)
        throw new Error("The selector " + selector + " failed to find an element, this is not supposed to happen, make sure your selector always find an element to forward clicks to.");
    if (!(forwardTarget instanceof HTMLElement)) {
        console.log("Unexpected element", forwardTarget);
        throw new Error("Found an unexpected element, what do I do with it?");
    }
    if (!isInteractive(forwardTarget) &&
        !isDescendantOf(forwardTarget, isInteractive))
        throw new Error("Found a non-interactive element " + forwardTarget.tagName + ", I can\u2019t click on it, nor any of the ancestors.");
    var actualClickLocation = e.target;
    if (!(actualClickLocation instanceof Element))
        return;
    if (actualClickLocation === forwardTarget ||
        isDescendantOf(actualClickLocation, function (el) { return el === forwardTarget; }))
        return;
    if (isInteractive(actualClickLocation) ||
        isDescendantOf(actualClickLocation, isInteractive))
        return;
    // Simulated click does not bring focus
    forwardTarget.focus();
    // Copies modifiers and which mouse buttons used
    var eventCopy = new MouseEvent("click", e.nativeEvent);
    forwardTarget.dispatchEvent(eventCopy);
}
exports.forwardClick = forwardClick;
//# sourceMappingURL=forwardClick.js.map